import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getStorageWithExpiry,
  isValidEncMsisdn
} from 'helpers';

import {
  CacheKeys,
  CacheStrategy
} from '../../../constants';

export class SocialBundleProvider {

  static STATE = AppState.with('SocialBundleProvider');

  static BASE_URL = Environment.current.socialBundleHost  + Environment.current.socialBundleBase;

  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    };

  static getMsisdn() {
    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async getEligibility(socialMedia) {
    if (!isValidEncMsisdn(SocialBundleProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return SocialBundleProvider.STATE.makeServiceCall(
      `${SocialBundleProvider.BASE_URL}${socialMedia}/eligibility`,
      {
        method: 'POST',
        headers: {
          ...SocialBundleProvider.DEFAULT_HEADERS
        },
        pathParams: {
          socialMedia: socialMedia
        },
        bodyParams: {
          id: SocialBundleProvider.getMsisdn()
        },
        cacheStrategy: CacheStrategy.NetworkFirst,
        cacheKey: CacheKeys.SocialBundles
      }
    ).then((res) => {
        if (!res.result) {
          return {
            ok: false,
            error: new Error('social bundles verification error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error?.response?.data?.result,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

}